import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './planner.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export function PlannerIcon(props: IconProps) {
  return <Icon className={props.className} />;
}
